<template>
    <footer>       
           <div class="text-center">
                <Locale type=""></Locale>          
                <div class="copyright">
                    v{{commit_hash}}-{{package_version}}-{{serverVersion}}
                    <div class="mt-2">
                        <a href="https://www.sefos.se" target="_blank"><b-img class="footer logo" fluid src="/img/sefos.png" alt="SEFOS"></b-img></a>
                    </div>
                </div>
            </div>
    </footer>
</template>
<script>
import Locale from "@/components/Layout/Locale";
export default {
    components: {
        Locale
    },
    data() {
        return {
            version: '',
            commit_hash: process.env.VUE_APP_COMMIT_HASH,
            package_version: process.env.VUE_APP_PACKAGE_VERSION
        }
    },
    methods: {
        async getServerVersion() {
            if(this.$route.meta.showVersion)
            {
                let self = this;
                this.$http.get(this.user.hostname + "/version")
                .then(function(result) {
                    self.version = result.data; 
                });
            }
        }
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
        showHeader(){
            return this.$route.meta.showHeader;
        },
        current_year() {
            return new Date().getFullYear();
        },
        serverVersion(){
            if(this.version != "")
            {
                return "v." + this.version + " ";
            }
            return "";
        }
    },
    mounted() {
       this.getServerVersion();
    }
}
</script>
